import React from "react"

// Customizable Area Start
import { Box, Typography, Popover, Avatar, IconButton, Button } from "@mui/material"
import { createTheme, ThemeProvider, styled } from "@mui/material/styles"
import CircleIcon from "@mui/icons-material/Circle"
import DoneAllIcon from "@mui/icons-material/DoneAll"
// Customizable Area End

import NotificationsController, {
  MappedNotification,
  Props,
  configJSON,
} from "./NotificationsController"
import { bsLogo } from "../../navigationmenu/src/assets"
export default class Notifications extends NotificationsController {
  constructor(props: Props) {
    super(props)
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    return (
      // Customizable Area Start
      <ThemeProvider theme={theme}>
        <Popover
          open={this.props.open ? true : false}
          anchorEl={this.props.anchorEl}
          onClose={this.props.onClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          slotProps={{
            paper: {
              sx: {
                maxWidth: "932px",
                maxHeight: "554px",
                border: "1px solid #CBD5E1",
                borderRadius: "20px",
                boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.06)",
                padding: "45px 26px 49px 44px",
              },
            },
          }}
        >
          <NotificationHeader>
            <Typography data-test-id="notificationsTitle" variant="h2">
              {configJSON.myNotificationsTitle}
            </Typography>
            <MarkAllReadBtn
              data-test-id="readAllNotification"
              startIcon={<DoneAllIcon />}
              onClick={() => this.readAllNotificationList()}
            >
              Mark all as read
            </MarkAllReadBtn>
          </NotificationHeader>

          <NotificationList>
            {this.state.notifications.length > 0 ? (
              this.state.notifications.map(
                (notification: MappedNotification, index: number) => (
                  <NotificationItem
                    data-test-id="notificationClick"
                    key={String(notification.id)}
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.handleNotificationClick(notification.id)
                    }
                  >
                    <Box>
                      <img
                        className="avatar"
                        src={
                          notification.chatNotification
                            ? notification.userImage
                            : bsLogo
                        }
                        alt="profilepic"
                      />
                    </Box>
                    <NotificationContent>
                      {notification.chatNotification && (
                        <Typography variant="subtitle1">
                          {notification.title}
                        </Typography>
                      )}
                      {notification.message && (
                        <Typography
                          variant="subtitle1"
                          sx={{ color: "#64748B" }}
                        >
                          {notification.message}
                        </Typography>
                      )}
                      <Typography variant="subtitle2" sx={{ color: "#64748B" }}>
                        {notification.time}
                      </Typography>
                    </NotificationContent>
                    {notification.isUnread && (
                      <IconButton size="small">
                        <CircleIcon
                          sx={{ fill: "#652784", fontSize: "10px" }}
                        />
                      </IconButton>
                    )}
                  </NotificationItem>
                )
              )
            ) : (
              <Typography sx={{ padding: "10px", textAlign: "center" }}>
                No new notifications
              </Typography>
            )}
          </NotificationList>
        </Popover>
      </ThemeProvider>
      // Customizable Area End
    )
  }
}

// Customizable Area Start
const theme = createTheme({
  palette: {
    primary: {
      main: "#fff",
      contrastText: "#fff",
    },
  },
  typography: {
    fontFamily: "Montserrat !important",
    h2: {
      fontSize: "20px",
      fontWeight: "500",
      lineHeight: "24.38px",
      color: "#000000",
    },
    subtitle1: {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "24px",
      color: "#0F172A",
      "@media (max-width: 720px)": {
        fontSize: "14px",
      },
    },
    subtitle2: {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "22px",
      color: "#64748B",
    },
    body2: {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "22px",
      color: "#64748B",
    },
    caption: {
      fontSize: "14px",
      fontWeight: "600",
      lineHeight: "17.07px",
      color: "#652784",
    },
  },
})

const NotificationHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "26px",
  marginRight: "25px", // to align border with notification list
  borderBottom: "1px solid #E2E8F0",
})

const MarkAllReadBtn = styled(Button)({
  color: "#652784",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "12px",
  padding: "1px 12px",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.03)"
  }
})

const NotificationList = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  maxHeight: "400px",
  overflowY: "auto",
  paddingTop: "30px",
  paddingRight: "25px",
  "&::-webkit-scrollbar": {
    width: "5px",
    marginLeft: "25px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#CBD5E1",
    borderRadius: "10px",
  },
})

const NotificationItem = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "10px",

  "& .avatar": {
    borderRadius: "35px",
    width: "65px",
    height: "65px",
    background: "#EFF6FF",
    objectFit: "contain",
    padding: "8px",
  },
})

const NotificationContent = styled(Box)({
  flexGrow: 1,
})
// Customizable Area End
